/*  iceberg-ui  */
import { Icon } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Box, Typography } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/* NPM */
import i18n from 'i18n';

/* Images */
import { ReactComponent as GoogleAdminLogo } from 'images/Google_Admin.svg';

/*  React  */
import React from 'react';

const { t } = i18n;

const StyleText = ({ style, text }) => (
    <Typography variant="p" style={{ ...style }}>
        {text}
    </Typography>
);

export const SourceHeaderHelper = (theme) => {
    const filters = [
        {
            children: [
                {
                    default: true,
                    icon: (
                        <Box
                            key="desktop"
                            display="flex"
                            justifyContent="center"
                            sx={{
                                color: 'icon.primary',
                                lineHeight: 0,
                                width: '30px'
                            }}
                        >
                            <Icon size={FontSizes[2]} src="Laptop" />
                        </Box>
                    ),
                    key: 'desktop',
                    name: t('Sources.filter.desktop')
                },
                {
                    default: true,
                    icon: (
                        <Box
                            key="webActivity"
                            display="flex"
                            justifyContent="center"
                            sx={{
                                color: 'icon.primary',
                                lineHeight: 0,
                                width: '30px'
                            }}
                        >
                            <Icon size={FontSizes[2]} src="Cloud" />
                        </Box>
                    ),
                    key: 'webActivity',
                    name: t('Sources.filter.webActivity')
                }
            ],
            default: true,
            key: 'CATEGORIES',
            name: t('Sources.filter.applicationCategories')
        },
        {
            children: [
                {
                    default: true,
                    icon: (
                        <Box
                            key="webLogin"
                            display="flex"
                            justifyContent="center"
                            sx={{
                                color: 'icon.primary',
                                lineHeight: 0,
                                width: '30px'
                            }}
                        >
                            <Icon size={FontSizes[2]} src="VpnLock" />
                        </Box>
                    ),
                    key: 'webLogin',
                    name: t('Sources.filter.webLogin')
                },
                {
                    default: true,
                    icon: (
                        <Box
                            key="download"
                            display="flex"
                            justifyContent="center"
                            sx={{
                                color: 'icon.primary',
                                lineHeight: 0,
                                width: '30px'
                            }}
                        >
                            <Icon size={FontSizes[2]} src="CloudDownload" />
                        </Box>
                    ),
                    key: 'download',
                    name: t('Sources.filter.download')
                },
                {
                    default: true,
                    icon: (
                        <Box
                            key="microsoftSSO"
                            display="flex"
                            justifyContent="center"
                            sx={{
                                color: 'icon.primary',
                                lineHeight: 0,
                                width: '30px'
                            }}
                        >
                            <Icon size={FontSizes[2]} src="Microsoft" />
                        </Box>
                    ),
                    key: 'microsoftSSO',
                    name: t('Sources.filter.microsoftSSO')
                },
                {
                    default: true,
                    icon: (
                        <Box
                            key="googleSSO"
                            display="flex"
                            justifyContent="center"
                            sx={{
                                color: 'icon.primary',
                                lineHeight: 0,
                                width: '30px'
                            }}
                        >
                            <Icon size={FontSizes[2]} src="Google" />
                        </Box>
                    ),
                    key: 'googleSSO',
                    name: t('Sources.filter.googleSSO')
                },
                {
                    default: true,
                    icon: (
                        <Box
                            key="quickScan"
                            display="flex"
                            justifyContent="center"
                            sx={{
                                color: 'icon.primary',
                                lineHeight: 0,
                                width: '30px'
                            }}
                        >
                            <Icon size={FontSizes[2]} src="Clock" />
                        </Box>
                    ),
                    key: 'quickScan',
                    name: t('Sources.filter.quickScan')
                }
            ],
            default: true,
            key: 'BROWSER',
            name: t('Sources.filter.browser')
        },
        {
            children: [
                {
                    default: true,
                    icon: (
                        <Box
                            key="microsoftEntraID"
                            display="flex"
                            justifyContent="center"
                            sx={{
                                color: 'icon.primary',
                                lineHeight: 0,
                                width: '30px'
                            }}
                        >
                            <Icon size={FontSizes[2]} src="Windows" />
                        </Box>
                    ),
                    key: 'microsoftEntraID',
                    name: t('Sources.filter.microsoftEntraID')
                },
                {
                    default: true,
                    icon: (
                        <Box
                            alt="Google Logo"
                            key="google"
                            sx={{
                                color: theme?.palette.icon.primary,
                                marginX: '8px',
                                width: '14px'
                            }}
                        >
                            <GoogleAdminLogo />
                        </Box>
                    ),
                    key: 'google',
                    name: t('Sources.filter.google')
                }
            ],
            default: true,
            key: 'SSO',
            name: t('Sources.filter.sso')
        }
    ];

    const parameter = 'source';
    const filterableOptions = [];

    filters.forEach((f) => {
        const { key, name, children } = f;

        filterableOptions.push({
            ...f,
            children: children.map((c) => c.key),
            parameter,
            parent: true,
            render: (
                <StyleText
                    style={{ fontSize: FontSizes[1], fontWeight: 600 }}
                    text={name}
                />
            ),
            value: key,
            visualOnly: true
        });

        children.forEach((c) => {
            filterableOptions.push({
                ...c,
                child: true,
                parameter,
                parentKey: key,
                render: (
                    <Box display="flex" alignItems="center">
                        {c.icon}
                        <StyleText
                            key={`text_${c.key}`}
                            style={{ fontSize: FontSizes[1] }}
                            text={c.name}
                        />
                    </Box>
                ),
                value: c.key
            });
        });
    });

    const headers = {
        filterable: true,
        filterableOptions,
        name: 'Common.source',
        searchable: true,
        sortable: false,
        sortableFieldType: 'string',
        sortableKey: 'source', // Needed for searching within the filter options
        tooltip: 'unclassified_source',
        width: '10%'
    };

    return headers;
};
